import { AxiosError } from 'axios';
import { useContext, useState } from 'react';
import toast from 'react-hot-toast';

import { TableContext } from '../../../components/Table/TableContext';
import { LogComplaintDataType } from '../../../models/dashboard/driver-list/log-complaint';
import { ErrorHttpResponse, HttpConfig, SuccessHttpResponse } from '../../../models/https';
import useHttps from '../../useHttps';

const useLogComplaint = () => {
  const request = useHttps();
  const [loading, setLoading] = useState(false);
  const tableContext = useContext(TableContext);


  const onLogComplaintError = (
    err: AxiosError<ErrorHttpResponse>,
  ) => {
    toast.error(
      err?.response?.data?.message ??
      'Something went wrong while logging the complaint.',
    );
  };

  const onLogComplaintSuccess = (callback: () => void) => ({
    data,
    message,
  }: SuccessHttpResponse<any>) => {
    toast.success('Complaint logged successfully.');
    callback();
    tableContext?.setRefreshTable(!tableContext?.refreshTable);
  };

  const logComplaint = (data: LogComplaintDataType, driverId: string, callback: () => void) => {


    const url: HttpConfig = {
      url: `api/v1/dispatchers/validation/log-complaint`,
      method: 'post',
      data: { verificationIssueLog: data.verificationIssueLog, driverId },
    };
    request(
      url,
      onLogComplaintSuccess(callback),
      setLoading,
      onLogComplaintError,
    );
  };

  return { logComplaint, loading };
};

export default useLogComplaint;
